export const da = {
    Pick_Color: 'Vælg farve',
    Pick_quantity: 'Vælg antal',
    Print_Options: 'Trykmuligheder',
    Review_Order: 'Gennemse ordren',
};

export const nb = {
    Pick_Color: 'Velg farge',
    Pick_quantity: 'Velg antall',
    Print_Options: 'Trykk',
    Review_Order: 'Ordreoversikt',
};

export const fi = {
    Pick_Color: 'Valitse väri',
    Pick_quantity: 'Valitse määrä',
    Print_Options: 'Painatukset',
    Review_Order: 'Tilauksen yhteenveto',
};

export const sv = {
    Pick_Color: 'Välj färg',
    Pick_quantity: 'Välj antal',
    Print_Options: 'Välj tryck',
    Review_Order: 'Sammanfattning',
};

export const at = {
    Pick_Color: 'Farbe wählen',
    Pick_quantity: 'Anzahl wählen',
    Print_Options: 'Druckmöglichkeiten',
    Review_Order: 'Bestellübersicht',
};

export const de = {
    Pick_Color: 'Farbe wählen',
    Pick_quantity: 'Anzahl wählen',
    Print_Options: 'Druckmöglichkeiten',
    Review_Order: 'Bestellübersicht',
};

export const fr = {
    Pick_Color: 'Choisir une couleur',
    Pick_quantity: 'Choisir la quantité',
    Print_Options: "Options d'impression",
    Review_Order: 'Vérifier la commande',
};

export const nl = {
    Pick_Color: 'Kies een kleur',
    Pick_quantity: 'Kies een hoeveelheid',
    Print_Options: 'Bedrukking',
    Review_Order: 'Controleer je bestelling',
};

export const en = {
    Pick_Color: 'Pick Color ',
    Pick_quantity: 'Pick quantity',
    Print_Options: 'Print Options',
    Review_Order: 'Review Order ',
};
